var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 8.03906C12.345 8.03906 12.6248 8.31888 12.6248 8.66406V11.3724H15.3332C15.6783 11.3724 15.9582 11.6522 15.9582 11.9974C15.9582 12.3426 15.6783 12.6224 15.3332 12.6224H12.6248V15.3307C12.6248 15.6759 12.345 15.9557 11.9998 15.9557C11.6547 15.9557 11.3748 15.6759 11.3748 15.3307V12.6224H8.6665C8.32133 12.6224 8.0415 12.3426 8.0415 11.9974C8.0415 11.6522 8.32133 11.3724 8.6665 11.3724H11.3748V8.66406C11.3748 8.31888 11.6547 8.03906 11.9998 8.03906Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 4.28906C7.74264 4.28906 4.2915 7.7402 4.2915 11.9974C4.2915 16.2546 7.74264 19.7057 11.9998 19.7057C16.257 19.7057 19.7082 16.2546 19.7082 11.9974C19.7082 7.7402 16.257 4.28906 11.9998 4.28906ZM3.0415 11.9974C3.0415 7.04984 7.05229 3.03906 11.9998 3.03906C16.9474 3.03906 20.9582 7.04984 20.9582 11.9974C20.9582 16.9449 16.9474 20.9557 11.9998 20.9557C7.05229 20.9557 3.0415 16.9449 3.0415 11.9974Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTimeIcon);
export default __webpack_public_path__ + "static/media/addTimeIcon.e5eea180832f8670c2860ae3ae3d7569.svg";
export { ForwardRef as ReactComponent };